import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'payment-period-terms',
        name: routeName.PAYMENT_PERIOD_TERMS,
        component: () => import('@/views/aplCatl640and631/B1/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '繳別變更說明', leaveAlert: true, code: 'B1', unableBack: true },
    },
    {
        path: 'payment-period',
        name: routeName.PAYMENT_PERIOD,
        component: () => import('@/views/aplCatl640and631/B1/paymentPeriod/Index.vue'),
        meta: { auth: true, metaTitle: '繳別變更', leaveAlert: true, code: 'B1', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.PAYMENT_PERIOD_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
